<template>
  <div class="answer-left">
    <div class="answer-left-title">{{questionTypeStr}}</div>
    <div class="answer-left-content">
      <div class="answer-subject clearfix" >
        <span class="fl">{{parseInt(curQuestionIndex) + 1}}.</span>
        <p class="fl" v-html="$props.curQuestion.title"></p>
      </div>
      <!-- <div class="answer-subject">1、2014年11月5日至11日，2014年亚太经合组织（APEC）领导人会议周各项活动由北京市主办，其间11月10日至11日召开了APEC第二十二次领导人非正式会议。下列有关APEC的说法有误的是（ ）</div> -->
      <div class="answer-option">
        <ul>
          <li
            v-for="(item,index) in options"
            :key="`analyoption${index}`"
            :class="[{'answer-option-user': item.status == 2}, {'answer-option-error': item.status == 1}]"
          >
            <span :class="['answer-radio', {'answer-radio-user': item.status == 2}, {'answer-radio-error': item.status == 1}]"></span>
            <div class="answer-option-text clearfix"  >
              <span class="fl">{{item.option}}</span>
              <p class="fl" v-html="item.content"></p>
            </div>
          </li>

        </ul>
      </div>
    </div>
    <div class="answer-analysis">
      <div class="answer-analysis-title">
        答案解析：正确答案是
        <span class="answer-correct">{{curQuestion.trueAnswer}}</span>
        <span v-show="!curQuestion.studentAnswer">，该题您未回答</span>
        <span v-show="curQuestion.studentAnswer">，您的答案是</span>
        <span v-show="curQuestion.studentAnswer" :class="userAnRClass">{{curQuestion.studentAnswer}}</span>。</div>
      <div class="answer-analysis-text" v-html="curAnalysis"> </div>
    </div>
    <div class="answer-button">
      <a href="javascript:;" class="btn-left" @click="$emit('btntopre')">上一题</a>
      <a href="javascript:;" class="btn-right" @click="$emit('btntonext')">下一题</a>
    </div>
  </div>
</template>

<script>
  export default {
    data: function () {
      return {
        analyValue: '' // 解析内容

      }
    },
    props: {
      curQuestion: Object,
      curQuestionIndex: Number,
      curAnalysis: String
    },
    computed:{
      questionId: function () {
        return this.$props.curQuestion.questionId
      },
      questionTypeStr: function () {
         const _arr = ['', '单选题', '多选题', '判断题']
         return _arr[parseInt(this.$props.curQuestion.questionType)]
      },
      userAnRClass: function () {
        if (this.$props.curQuestion.studentAnswer == this.$props.curQuestion.trueAnswer){
          return 'answer-correct'
        } else {
          return 'answer-error'
        }
      },
      options: function () {
        const  _options = this.$props.curQuestion.options.map(item=>{
            if (this.$props.curQuestion.studentAnswer.indexOf(item['option']) != -1){
              if (this.$props.curQuestion.trueAnswer.indexOf(item['option']) != -1) {
                return {...item, status: 2} //选对了
              } else {
                return {...item, status: 1} //选错了
              }

            }
            return item // 未选
          })
        return _options
      }
    },
    methods: {

    },
    mounted: function () {

    },

  }
</script>

<style scoped>

 .answer-left{
 	width: 865px;
 	float: left;
 	background-color: #fff;
 	border-radius: 6px;
 	min-height: 600px;
 }
 .answer-left-title{
 	margin: 15px 20px;
 	padding-bottom: 15px;
 	border-bottom: 1px solid #e5e5e5;
 	font-size: 18px;
 }
 .answer-left-content{
 	margin-top: 30px;
 }
 .answer-subject{
 	margin-left: 20px;
 	margin-right: 20px;
 	font-size: 16px;
 	color: #252525;
 	line-height: 24px;
 }
.answer-subject span{
  margin-right: 10px;
}
.answer-subject p{
  max-width: calc(100% - 36px);
}
 .answer-option{
 	margin-left: 20px;
 	margin-right: 20px;
 	margin-top: 20px;
 	overflow: hidden;
 }
 .answer-option ul{
 	margin:0;
 	padding:0;
 }
 .answer-option ul li{
 	list-style-type: none;
 	padding: 15px 20px;
 	color: #454545;
 	float: left;
 	width: 785px;
 	margin-top:5px;
 	margin-bottom: 5px;
 }
 .answer-option-text{
 	font-size: 16px;
 	margin-left: 30px;
 }
 .answer-option-text span{
   margin-right: 10px;
 }
 .answer-option-text p{
   max-width: calc(100% - 30px);
 }
 .answer-radio{
 	background-image: url(../../../assets/img/icon-option.png);
 	background-repeat: no-repeat;
 	background-size: 16px;
 	position: absolute;
 	display: inline-block;
 	vertical-align: middle;
 	width: 16px;
 	height: 16px;
 	margin-top:3px;
 }
 .answer-button{
 	width: 795px;
 	margin-left: 20px;
 	margin-right: 20px;
 	margin-top: 50px;
 	padding-bottom: 50px;
 	overflow: hidden;
 }
 .answer-button a.btn-left{
 	width: 100px;
 	height: 32px;
 	border-radius: 4px;
 	border: 1px solid #0AAC50;
 	color: #0AAC50;
 	float: left;
 	text-align: center;
 	line-height: 32px;
 	text-decoration: none;
 }
 .answer-button a.btn-right{
 	width: 100px;
 	height: 32px;
 	border-radius: 4px;
 	border: 1px solid #0AAC50;
 	color: #0AAC50;
 	float: right;
 	text-align: center;
 	line-height: 32px;
 	text-decoration: none;
 }
 .answer-button a:hover.btn-right{
 	background:#0AAC50;
 	color: #fff;
 }
 .answer-button a:hover.btn-left{
 	background:#0AAC50;
 	color: #fff;
 }
 .answer-analysis{
   margin-left: 20px;
   margin-right: 20px;
 }
 .answer-analysis-title{
   color: #252525;
   font-weight: bold;
   margin-top: 30px;
 }
 .answer-correct{
   color: #0AAC50;
   margin-left: 6px;
 }
 .answer-error{
   color: #FF3A3A;
   margin-left: 6px;
 }
 .answer-analysis-text{
   color: #252525;
   line-height: 1.7;
   margin-top: 10px;
 }
 .right-asheet ul li a.asheet-error{
   background:#FF3A3A;
   color: #fff;
   border:1px solid #FF3A3A;
 }
 .right-asheet ul li a:hover.asheet-error{
   background:#ff2a2a;
   color: #fff;
   border:1px solid #ff2a2a;
 }
 .answer-radio-user{
   background-image: url(../../../assets/img/icon-option1.png);
   background-repeat: no-repeat;
   background-size: 16px;
   position: absolute;
   display: inline-block;
   vertical-align: middle;
   width: 16px;
   height: 16px;
   margin-top:3px;
 }
 .answer-option ul li.answer-option-user{
   color:#0AAC50;
   cursor:pointer;
   background:#e1ffeb;
   border-radius: 6px;
 }
 .answer-radio-user{
   background-image: url(../../../assets/img/icon-option1.png);
   background-repeat: no-repeat;
   background-size: 16px;
   position: absolute;
   display: inline-block;
   vertical-align: middle;
   width: 16px;
   height: 16px;
   margin-top:3px;
 }
 .answer-option ul li.answer-option-user{
   color:#0AAC50;
   cursor:pointer;
   background:#e1ffeb;
   border-radius: 6px;
 }
 .answer-radio-error{
   background-image: url(../../../assets/img/icon-option2.png);
   background-repeat: no-repeat;
   background-size: 16px;
   position: absolute;
   display: inline-block;
   vertical-align: middle;
   width: 16px;
   height: 16px;
   margin-top:3px;
 }
 .answer-option ul li.answer-option-error{
   color:#ff3a3a;
   cursor:pointer;
   background:#FFE5E5;
   border-radius: 6px;
 }
</style>



// WEBPACK FOOTER //
// src/components/WrongBook/children/Aquestion.vue